












































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIconBoxArrowRight,
    BIcon,
    NextPrevBtn,
    Footer
  }
})
export default class OnlineCultureCinema extends Vue {
  protected nxtprevOnlineCultureCinema = {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail3.png",
    NextImage: "/thumbnail4.png",
    PrevLink: "/CultureenLigne/Art",
    NextLink: "/CultureenLigne/Musique"
  };
}
